export const API_URL = import.meta.env.VITE_API_URL || 'https://v7.newspark.ca/gql';
